<template>
  <div class="web-body">

    <h1 class="">Terms of Services</h1>
    <div style="text-indent:2em;">
      <h4>Welcome to Wonder Games’s official website where you can find policies and terms governing your use of
        products and services provided by Wonder Games its subsidiaries and affiliates (collectively as “Company,”
        “we,” “us” and “our”).</h4>
      <h4>These Terms of Service (“ToS”) constitute a legal agreement between the user of our products and services
        (“user” or “you”) and the Company. It applies when a user accesses, uses or visits our website located at
        http://wonder.wiki (the “Site”), the associated mobile application available for download in the Google
        Play Store and App Store. In these ToS, the term “Service” means and includes the Site, the App and these
        services, individually or collectively.</h4>
      <h4>We prepared these ToS to help explain the terms that apply to your use of the Service.</h4>
      <h3>1. Consent</h3>
      <h4>By visiting the Site, downloading the App, or otherwise using the Service, you indicate your agreement to be
        bound by these ToS. If you do not agree with these ToS, you must not use the Service, and uninstall the App if
        you have already downloaded it.</h4>
      <h3>2. Privacy Policy</h3>
      <h4>Our Privacy Policy, located at http://wonder.wiki/#/privacy_en is part of and is governed by these ToS. By
        agreeing to these ToS, you agree to be bound by the terms of the Privacy Policy and agree that we may use
        information collected from you in accordance with its terms.</h4>
      <h3>3. Notice Regarding Dispute Resolution</h3>
      <h4>These ToS contain provisions that govern how claims you and we may have against each other are resolved,
        including an agreement and obligation to arbitrate disputes, which, subject to limited exceptions, will
        require you to submit claims you have against us to binding arbitration, unless you opt-out of arbitration as
        described below. If you do not opt-out of arbitration, you will only be permitted to pursue claims and seek
        relief (including monetary, injunctive, and declaratory relief) against us on an individual basis, not as part
        of any class or representative action or proceeding.</h4>
      <h3>4. Updates to these ToS</h3>
      <h4>We may modify these ToS from time to time. We will notify you of material changes in accordance with
        applicable laws. If you do not agree with the proposed changes, you should discontinue your use of the Service
        and uninstall the App. If you continue using the Service after the new terms take effect, you will be bound by
        the modified ToS.</h4>

      <h3>5. Affirmative Representations</h3>
      <h4>When you use the Service, you represent that:</h4>
      <ul>
        <li>• your use of the Service does not violate any applicable law or regulation;</li>
        <li>• you are 13 years of age or older;</li>
        <li>• you are of sufficient legal age or otherwise have legal capacity to legally enter into these ToS.</li>
      </ul>
      <h3>6. Prerequisites and Activation</h3>
      <h4>In order to use the Service, you must first agree to be bound by the terms of these ToS and our Privacy
        Policy. In order to be able to activate the App, you may need to agree to allow the App to have access to the
        following information and features located on the user’s device:
      </h4>
      <ul>
        <li> • Device and Application History</li>
        <li> • Identity</li>
        <li> • Photos and media files</li>
        <li> • Camera</li>
        <li> • microphone</li>
        <li> • Wi-Fi Connections</li>
        <li> • Device ID and Call Information.</li>
      </ul>

      <h3>7. Important Precautions</h3>
      <h4>I SOME FEATURES OF THE APP COULD AFFECT OTHER PROGRAMS, APPS, AND FUNCTIONS ON YOUR DEVICE INCLUDING BUT NOT
        LIMITED TO REMOVAL/UNINSTALLATION OF OTHER APPS, AND THE DELETION OF CONTENT FROM YOUR DEVICE.
        BEFORE USING THIS APP, YOU SHOULD CAREFULLY READ ALL INSTRUCTIONS AND TIPS AND JUDGE WHETHER THE APP MEETS
        YOUR PURPOSE AND NEEDS.
        BY INSTALLING THE PRODUCT, YOU UNDERSTAND AND AGREE TO ASSUME ALL RISKS ASSOCIATED WITH INSTALLATION AND USE
        OF THIS APP. </h4>
      <h3> 8. Our Intellectual Property Rights</h3>
      <h4>
        The Service and the trademarks, service marks, and logos contained on the Service, are owned by or licensed to
        us and are subject to copyright and other intellectual property rights under United States and foreign laws
        and international conventions. The Service is for your information and personal use only and not for
        commercial
        exploitation. We reserve all rights in and to the Service. If you download or print a copy of the Service for
        your own
        personal use, you must retain all trademark, copyright and other proprietary notices contained in and on the
        Service. You agree that the Company will be entitled to all legal and equitable remedies otherwise available
        to it to
        protect the intellectual property rights and those of its licensors including, without limitation, the right
        to seek and obtain injunctive relief and enforce the same against you.
      </h4>
      <h3> 9. License</h3>
      <h4>(1) The Company grants each user a non-exclusive and limited license to use the object code version of the
        App
        for non-commercial purposes. Each user may make a single copy of the App in object code form for archival or
        backup purposes. The user must include all Notices on all such copies. Users are prohibited from reverse
        engineering, decompiling or disassembling the App or attempting to gain access to the source code of the App
        except and only to the extent that it is expressly permitted by applicable law. To the extent applicable law
        permits contractual waiver of such right, you hereby waive your rights to do so.
      </h4>
      <h4>(2) Each user is prohibited from transferring or assigning the App or these ToS and/or any rights or
        obligations hereunder without the prior written consent of the Company.
      </h4>
      <h4>(3) Your rights under this ToS will automatically terminate if you breach any of your material
        obligations
        under this ToS.
      </h4>
      <h4>(4) Promptly after such any termination of this ToS, you will destroy all copies of the App and
        uninstall
        the
        App from your device.
      </h4>
      <h4>(5) All rights not expressly granted are reserved. </h4>
      <h3> 10. Prohibited Activities</h3>
      <h4> You agree that, in connection with your use of the Service, you will not: </h4>
      <ul>
        <li> • decompile, disassemble, modify, translate, adapt, reverse engineer, create derivative works from or
          sublicense the Service, or any portion thereof;
        </li>
        <li>
          • or circumvent, disable or otherwise interfere with security related features of the Service or features
          that prevent or restrict use or copying of any part of the App.
        </li>
      </ul>

      <h3>11. Disclaimer of Warranties</h3>

      <h4>
        TO THE EXTENT PERMITTED BY APPLICABLE LAW, ALL MATERIALS OR ITEMS PROVIDED THROUGH THE SERVICE ARE PROVIDED
        “AS
        IS” AND “AS AVAILABLE,” WITHOUT WARRANTY OR CONDITIONS OF ANY KIND.
        TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY,
        RELIABILITY, TIMELINESS OR COMPLETENESS OF THE SERVICE’S CONTENT, THE CONTENT OF ANY SITE LINKED TO THE
        SERVICE,
        INFORMATION OR ANY OTHER ITEMS OR MATERIALS ON THE SERVICE OR LINKED TO BY THE SERVICE.
        WE ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (A) ERRORS, MISTAKES OR INACCURACIES OF CONTENT AND
        MATERIALS,
        (B) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE
        SERVICE, (C) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
        STORED THEREIN, (D) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICE, (E) ANY BUGS,
        VIRUSES,
        TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICE BY ANY THIRD PARTY, AND/OR (F)
        ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
        RESULT
        OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SERVICE.
        BY OPERATING THE SERVICE, WE DO NOT REPRESENT OR IMPLY THAT WE ENDORSE ANY MATERIALS OR ITEMS AVAILABLE ON OR
        LINKED TO BY THE SERVICE, INCLUDING WITHOUT LIMITATION, CONTENT HOSTED ON THIRD PARTY SITES, OR THAT WE
        BELIEVE
        ANY MATERIALS OR ITEMS TO BE ACCURATE, USEFUL OR NON-HARMFUL.
        WE CANNOT GUARANTEE AND DO NOT PROMISE ANY SPECIFIC RESULTS FROM USE OF THE SERVICE. NO ADVICE OR INFORMATION,
        WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM US SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THESE TERMS
        OF SERVICE.
        YOU AGREE THAT YOUR USE OF THE SERVICE WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE
        AND
        EACH OF OUR ADVERTISERS, LICENSORS, SUPPLIERS, OFFICERS, DIRECTORS, INVESTORS, EMPLOYEES, AGENTS, SERVICE
        PROVIDERS AND OTHER CONTRACTORS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICE
        AND
        YOUR USE THEREOF. </h4>
      <h3> 12. Limited of Liability</h3>
      <h4>
        TO THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
        INDIRECT, CONSEQUENTIAL, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT DAMAGES ARISING FROM
        YOUR USE OF THE SERVICE, ANY MATERIALS, OR ANY OTHER CONTENT THEREIN. NOTWITHSTANDING ANYTHING TO THE CONTRARY
        CONTAINED IN THESE TERMS OF SERVICE, OUR LIABILITY TO YOU IN RESPECT OF ANY LOSS OR DAMAGE SUFFERED BY YOU AND
        ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OF SERVICE, WHETHER IN CONTRACT, TORT OR FOR BREACH OF
        STATUTORY DUTY OR IN ANY OTHER WAY SHALL NOT EXCEED $50.
        13. Exception
        Notwithstanding any terms set forth in these ToS, if any of the provisions set forth in Section “Limitation of
        Liability” above are held unenforceable, void or inapplicable under applicable law, then any such provision
        shall not apply to you but the rest of these ToS shall remain binding on you and the Company.
        In addition, the limitation on liability is inapplicable where attorneys’ fees, court costs, or other damages
        are mandated by statue. Notwithstanding any provision in these ToS, nothing in these ToS is intended to, nor
        shall it be deemed or construed to, limit any rights available to user under applicable federal or state
        consumer protection law.</h4>
      <h3> 14. Copyright Policy</h3>
      <h4>
        Any person who believes that any content available on or through the Service infringes on that person’s
        copyrights, may submit a notification pursuant to the Digital Millennium Copyright Act (“DMCA”) to us
        at nantongxiaobei@163.com and include the following information:</h4>
      <ul>
        <li> • A physical or electronic signature of a person authorized to act on behalf of the owner or an agent of
          an
          exclusive right that is allegedly infringed;
        </li>
        <li>
          • Identification of the copyright claimed to have been infringed;
        </li>
        <li>
          • Identification of the material that is claimed to be infringing, and where it is located in the App or
          Service;
        </li>
        <li>
          • Information reasonably sufficient to permit us to contact you;
        </li>
        <li>
          • A statement that you have a good faith belief that use of the material in the manner complained of is not
          authorized by the copyright owner, its agent, or the law, and;
        </li>
        <li>
          • A statement, made under penalty of perjury, that the above information is accurate, and that you are the
          copyright owner or are authorized to act on behalf of the owner.
        </li>
      </ul>
      <h4> We respect the intellectual property rights of others and will respond to clear notices of alleged
        infringement. You acknowledge that if you fail to comply with all of the requirements of this section, your
        notice may
        not be valid.
      </h4>
      <h3> 15. Our Management of the Service; User Misconduct</h3>
      <h4> (1) Our Right to Manage the Service</h4>
      <h5>We reserve the right, but do not undertake the obligation to: (a) monitor or review the Service for
        violations
        of these ToS and for compliance with our policies; (b) report to law enforcement authorities and/or take
        legal
        action against anyone who violates these ToS; (c) manage the Service in a manner designed to protect our and
        third parties’ rights and property or to facilitate the proper functioning of the Service; (d) to terminate
        or
        block you and other users for violating these ToS.</h5>
      <h4> (2) Our Right to Terminate Userse
      </h4>
      <h5> WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF SERVICE, WE RESERVE THE RIGHT TO, IN OUR SOLE
        DISCRETION,
        AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICE TO ANY PERSON FOR ANY REASON OR FOR
        NO
        REASON AT ALL, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY OR COVENANT
        CONTAINED
        IN
        THESE TERMS OF SERVICE, OR OF ANY APPLICABLE LAW OR REGULATION.</h5>
      <h3> 16. Service Provided by Third Party:</h3>
      <h4> (1) Google Play and Apple App Store: </h4>
      <h5> These ToS are between you and Wonder Games and not with the Google Play Store or Apple App
        Store（collectively
        referred as” Third Party App Store”）. You agree to comply with, and your license to use the Service is
        conditioned upon, your compliance with, the applicable Third Party App Store terms and conditions. To
        the
        extent
        that other terms and conditions of the Google Play Store are less restrictive than, or otherwise
        conflict
        with,
        these ToS, the more restrictive term will apply.</h5>
      <h4> (2) In-App Purchase Terms: </h4>
      <h5>
        We may offer certain enhanced features of the Services which you can purchase as a monthly, yearly or
        lifetime
        subscription. You can review a description of our enhanced features when you want to make a
        subscription.
        You
        acknowledge and agree that all billing and transaction processes are processed by Apple App Store/Google
        Play
        .So all payments would also be governed by the Apple App Store and Google Play’s terms and conditions.
        If
        you
        have any payment related issues with In-App Purchases, you can either contact us or contact Google Play
        or
        Apple
        App Store directly.
        If you are under the age of 18 or other age of legal majority in accordance with the applicable
        regulation
        in
        the country of your nationality, then you must acquire permission from your parents’ or other guardians
        in
        order
        to make the purchase. By completing the purchase, you are informing us that you have gain all legally
        necessary
        permission to allow you to proceed your purchase
        When you purchase a Subscription, Google pay or Apple pay may ask you to provide certain information
        relevant
        to
        your transaction, such as your credit card number, the expiration date of your credit card and your
        address(es)
        for billing and delivery. Such information will be collected, processed by Google or Apple in accordance
        with
        their separate privacy policy.
        If any In-App Purchase is not successfully completed or does not work once you have completed the
        payment
        following the instructions, we will , after becoming aware of the fault, or being notified of the fault
        by
        you,
        investigate the fault . In no event will we charge you anything further to fix the fault. In the event
        that
        we
        are not able to resolve your concern related to In-App Purchase or are unable to do so within a
        reasonable
        period of time, or if you wish to request a refund, you can also contact the Google or Apple directly.</h5>
      <h3> 17. Third Party Sites</h3>
      <h4>
        The Service may contain links to websites operated by third parties (“Third Party Sites”). For example,
        you
        can
        access third-party advertisements through links on the Service, and you may be able to share information
        with
        Third Party Sites through links on the Service. Please note that we do not own or operate the
        Third-Party
        Sites,
        and we have not reviewed, and cannot review, all of the material, including goods or services, made
        available
        through Third Party Sites.
        The availability of these links on the Service does not represent, warrant or imply that we endorse any
        Third-Party Sites or any materials, opinions, goods or services available on them. Third party materials
        accessed through or used by means of the Third-Party Sites may also be protected by copyright and other
        intellectual property laws.
        THESE TOS DO NOT APPLY TO THIRD PARTY SITES. BEFORE VISITING A THIRD-PARTY SITE THROUGH LINKS OR OTHER
        MEANS
        PROVIDED ON OR THROUGH THE SERVICE, YOU SHOULD REVIEW THE THIRD-PARTY SITE’S TERMS AND CONDITIONS AND
        PRIVACY
        POLICY, AND INFORM YOURSELF OF THE REGULATIONS, POLICIES AND PRACTICES OF THESE THIRD-PARTY SITES.</h4>
      <h3> 18. Governing Law</h3>
      <h4>
        This TOS will in all respects be governed by and construed and enforced in accordance with the laws of
        the
        State
        of California (without giving effect to any choice or conflict of laws). The United Nations Convention
        on
        Contracts for the International Sale of Goods will not apply to this Agreement.
        19. Arbitration Agreement
        Please Read This Following Clause Carefully. It May Significantly Affect Your Legal Rights, Including
        Your
        Right
        to File a Lawsuit in Court</h4>
      <h4> (1) Initial Dispute Resolution</h4>
      <h5> We are available by email at the address provided in the “How to Contact Us” Section to address any
        concerns
        a
        user may have regarding the Service. Most concerns may be quickly resolved in this manner. For any
        dispute
        you
        have with the Company, you agree to first contact us and attempt to resolve the dispute with us
        informally.
        We
        each agree to resolve any dispute arising out of or in connection with, or relating to this Agreement
        directly
        through consultation and good faith negotiations, which shall be a precondition to either party
        initiating a
        lawsuit or arbitration.</h5>
      <h4> (2) Agreement to Binding Arbitration.</h4>
      <h5> If we do not reach an agreed upon solution within a period of thirty (30) days from the time informal
        dispute
        resolution is pursued pursuant to section “Initial Dispute Resolution” above, then either party may
        initiate
        binding arbitration.
        All claims arising out of or relating to these ToS (including its formation, performance and breach),
        the
        parties’ relationship with each other and/or your use of the Service shall be finally settled by binding
        arbitration administered on a confidential basis by the American Arbitration Association in accordance
        with
        the
        provisions of the Consumer Arbitration Rules of the American Arbitration Association (the “AAA”),
        excluding
        any
        rules or procedures governing or permitting class actions. The arbitrator, and not any federal, state or
        local
        court or agency, shall have exclusive authority to resolve all disputes arising out of or relating to
        the
        interpretation, applicability, enforceability or formation of these ToS, including, but not limited to,
        any
        claim that all or any part of these ToS is void or voidable. The arbitrator shall be empowered to grant
        whatever
        relief would be available in a court under law or in equity. The arbitrator’s award shall be binding on
        the
        parties and may be entered as a judgment in any court of competent jurisdiction. The interpretation and
        enforcement of these ToS shall be subject to the Federal Arbitration Act.
        THE AAA’S RULES GOVERNING THE ARBITRATION MAY BE ACCESSED AT WWW.ADR.ORG OR BY CALLING THE AAA AT
        1.800.778.7879. TO THE EXTENT THE FILING FEE FOR THE ARBITRATION EXCEEDS THE COST OF FILING A LAWSUIT,
        WE
        WILL
        PAY THE ADDITIONAL COST. IF WE ARE REQUIRED TO PAY THE ADDITIONAL COST OF THE FILING FEES, YOU SHOULD
        SUBMIT
        A
        REQUEST FOR PAYMENT OF FEES TO AAA ALONG WITH YOUR FORM FOR INITIATING THE ARBITRATION, AND WE WILL MAKE
        ARRANGEMENTS TO PAY ALL NECESSARY FEES DIRECTLY TO AAA. THE ARBITRATION RULES ALSO PERMIT YOU TO RECOVER
        ATTORNEY’S FEES IN CERTAIN CIRCUMSTANCES.
        THE PARTIES UNDERSTAND THAT, ABSENT THIS MANDATORY PROVISION, THEY WOULD HAVE THE RIGHT TO SUE IN COURT
        AND
        HAVE
        A JURY TRIAL. THEY FURTHER UNDERSTAND THAT, IN SOME INSTANCES, THE COSTS OF ARBITRATION COULD EXCEED THE
        COSTS
        OF LITIGATION AND THE RIGHT TO DISCOVERY MAY BE MORE LIMITED IN ARBITRATION THAN IN COURT.</h5>
      <h4> (3) Class Action and Class Arbitration Waiver</h4>
      <h5> You and the Company each further agree that any arbitration shall be conducted in your respective
        individual
        capacities only and not as a class action or other representative action, and you and the Company each
        expressly
        waive your respective right to file a class action or seek relief on a class basis. If any court or
        arbitrator
        determines that the class action waiver set forth in this paragraph is void or unenforceable for any
        reason
        or
        that an arbitration can proceed on a class basis, then the arbitration provision set forth above in
        Section
        “Agreement to Binding Arbitration Above” shall be deemed null and void in its entirety and the parties
        shall
        be
        deemed to have not agreed to arbitrate disputes.</h5>
      <h4> (4) Exception - Small Claims Court Claims.</h4>
      <h5> Notwithstanding the parties’ agreement to resolve all disputes through arbitration, either party may
        seek
        relief
        in a small claims court for disputes or claims within the scope of that court’s jurisdiction.</h5>
      <h4> (5) 30 Day Right to Opt Out.</h4>
      <h5> You have the right to opt-out and not be bound by the arbitration and class action waiver provisions set
        forth
        in this Section “Arbitration Agreement” by sending written notice of your decision to opt-out to the
        address
        provided in the “How to Contact Us” Section.
        The notice must be sent by you within thirty (30) days of your downloading of the App, otherwise you
        will be
        bound to arbitrate disputes in accordance with the terms of those sections. If you opt-out of these
        arbitration
        provisions, we also will not be bound by them.</h5>
      <h3> 20. Exclusive Venue for Litigation</h3>
      <h4> To the extent that the arbitration provisions set forth in above do not apply, the parties agree that
        any
        litigation between them shall be filed exclusively in state or federal courts located in Santa Clara
        County,
        California (except for small claims court actions which may be brought in the county where you reside).
        The
        parties expressly consent to exclusive jurisdiction in California for any litigation other than small
        claims
        court actions.</h4>
      <h3> 21. Entire Agreement</h3>
      <h4>
        This ToS constitutes the entire agreement between you and the Company with respect to the subject matter
        hereof
        and supersedes all previous and contemporaneous written and oral representations, proposals,
        negotiations,
        and
        communications.</h4>
      <h3>
        22. Assignment</h3>
      <h4>
        The Company may assign this TOS or any of the rights or obligations hereunder and any causes of action
        arising
        hereunder to any third party without necessity or obligation of notice to users.</h4>
      <h3>
        23. Waivers</h3>
      <h4>
        The waiver or failure of either party to exercise in any respect any right or provision of these ToS
        will
        not
        be
        deemed a waiver of the applicable right or provision.</h4>
      <h3>
        24. Severability.</h3>
      <h4>
        These ToS will operate to the fullest extent permissible by law. If any provision or part of a provision
        of
        these ToS is unlawful, void, or unenforceable, that provision or part of the provision is deemed
        severable
        from
        these ToS and shall not affect the validity and enforceability of any remaining provisions.</h4>
      <h3>
        25. Notice to California Users.</h3>
      <h4>
        Under California Civil Code Section 1789.3, users located in California are entitled to the following
        consumer
        rights notice: If a user has a question or complaint regarding the Service, please send an email to the
        email
        address provided in the “How to Contact Us” Section. California residents may reach the Complaint
        Assistance
        Unit of the Division of Consumer Services of the California Department of Consumer Affairs by mail at
        1625
        North
        Market Blvd., Suite N 112, Sacramento, CA 95834, or by telephone at (916) 445-1254 or (800) 952-5210.</h4>
      <h3>
        26. Force Majeure</h3>
      <h4>
        The Company will not be responsible for any failure to perform its obligations under this TOS due to
        circumstances beyond its reasonable control including, without limitation, acts of God, war, riot,
        terrorism,
        embargoes, acts of civil or military authorities, fire, flood, or accidents.</h4>
      <h3>
        27. Independent Contractors.</h3>
      <h4>
        Nothing in these ToS shall be deemed to create an agency, partnership, joint venture, employer-employee
        or
        franchisor-franchisee relationship of any kind between us and any user.</h4>
      <h3> 28. How to Contact Us</h3>
      <h4>
        If you have any questions about these ToS, please contact us as follows:</h4>
      <ul>
        <li> • (1) Open the Google Play/Apple App Store;</li>
        <li> • (2) Browse or search the app you're using;</li>
        <li> • (3) Tap the app to open the detailed page;</li>
        <li> • (4) Scroll down to review the contact information listed.</li>
      </ul>

    </div>
  </div>

</template>

<script>
export default {
  name: "terms_en",
  components: {}
}
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0%;
}

ul li {
  padding-left: 20px;
  line-height: 25px;
}

h4,
h5 {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/terms_en.vue